import React from 'react';

type Props = {
  vehicleId: number;
  /** Public path or full URL for this build — same payload as the printed QR. */
  shareUrl: string;
  isOwner: boolean;
  collectionEnabled?: boolean | null;
};

/**
 * Visitor Passport guidance on the public build page.
 * Encounters are camera-scanned only (manual entry disabled for fraud prevention).
 */
const VehiclePassportCollectCta: React.FC<Props> = ({
  isOwner,
  collectionEnabled = true,
}) => {
  if (isOwner || collectionEnabled === false) {
    return null;
  }

  return (
    <section
      className="card mt-4 px-5 py-4 space-y-2"
      aria-label="Passport encounter for this build"
    >
      <h2 className="text-sm font-semibold text-white">Seen this build in person?</h2>
      <p className="text-muted text-sm">
        Scan the build QR with the Bilt:Spec mobile camera to log it in your Passport. Manual entry is
        disabled so encounters stay tied to a real scan.
      </p>
    </section>
  );
};

export default VehiclePassportCollectCta;
